import startCase from 'lodash/startCase'
import * as React from 'react'

import { SchoolListingType } from 'main/gql/globalTypes'
import { UnreachableCaseError } from 'main/util/ts'

import { ILazySchoolListingTarget, ILeadStatus, LazyTarget, LazyTargetType } from '../types'
import ExternalSchoolContent from './ExternalSchoolContent'
import { Container, ContentContainer, LeadStatus, LeadStatusContainer } from './MapCallout.styles'
import SchoolContent from './SchoolContent'

interface IProps {
  lazyTarget: LazyTarget
  leadStatus?: ILeadStatus
}

export default function MapCallout(props: IProps) {
  const { lazyTarget, leadStatus } = props

  return (
    <Container data-pendo={pendoTag(lazyTarget)}>
      {leadStatus && (
        <LeadStatusContainer>
          <LeadStatus>{startCase(leadStatus.type)}</LeadStatus>
        </LeadStatusContainer>
      )}
      <ContentContainer>{renderContent(lazyTarget, leadStatus)}</ContentContainer>
    </Container>
  )
}

function pendoTag(lazyTarget: LazyTarget) {
  switch (lazyTarget._type) {
    case LazyTargetType.School:
      return `mapCallout-wonderschool-${lazyTarget.id}`
    case LazyTargetType.SchoolListing:
      switch (lazyTarget.type) {
        case SchoolListingType.INTERNAL:
          return `mapCallout-wonderschool-${lazyTarget.id}`
        case SchoolListingType.EXTERNAL:
          return `mapCallout-external_school-${lazyTarget.id}`
        default:
          throw new UnreachableCaseError(lazyTarget.type)
      }
    default:
      throw new UnreachableCaseError(lazyTarget)
  }
}

function renderContent(lazyTarget: LazyTarget, leadStatus?: ILeadStatus) {
  switch (lazyTarget._type) {
    case LazyTargetType.School:
      return <SchoolContent schoolId={lazyTarget.id} leadStatus={leadStatus} />
    case LazyTargetType.SchoolListing:
      return renderSchoolListingTargetContent(lazyTarget)
    default:
      throw new UnreachableCaseError(lazyTarget)
  }
}

function renderSchoolListingTargetContent(
  lazyTarget: ILazySchoolListingTarget,
  leadStatus?: ILeadStatus,
) {
  const { id, type } = lazyTarget

  switch (type) {
    case SchoolListingType.INTERNAL:
      return <SchoolContent schoolId={id} leadStatus={leadStatus} />
    case SchoolListingType.EXTERNAL:
      return <ExternalSchoolContent externalSchoolId={id} />
    default:
      throw new UnreachableCaseError(type)
  }
}
